import axios from "axios";

export const SYSTEM_USER_URL = "/User";

/** Belli Bir Kullanıcı Listesini Elde Eder */
export function getSystemUsers(queryParams) {
  return axios.post(`${SYSTEM_USER_URL}/GetSystemUsers`, queryParams);
}

/** Belli Bir Kullanıcı Listesini Sayfalama Olmadan Elde Eder */
export function getAllSystemUsers(queryParams) {
  return axios.post(`${SYSTEM_USER_URL}/GetAllSystemUsers`, queryParams);
}

/** Yeni Bir Kullanıcı Elde Eder */
export function getNewSystemUser() {
  return axios.get(SYSTEM_USER_URL);
}

/** Belli Bir Kullanıcıyı Elde Eder */
export function getSystemUser(id) {
  return axios.get(`${SYSTEM_USER_URL}/${id}`);
}

/** Belli Bir Kullanıcıyı Kaydeder */
export function saveSystemUser(user) {
  return axios.post(SYSTEM_USER_URL, user);
}

/** Belli Bir Kullanıcı Listesini Siler */
export function deleteSystemUsers(ids) {
  return axios.post(`${SYSTEM_USER_URL}/Delete`, { ids });
}